<script setup lang="ts">
import MenuDropdown from '~/components/ui/MenuDropdown.vue';
import NetworkIcon from '~/components/icons/network.vue';
import NotificationIcon from '~/components/icons/notification.vue';
import synchronize from '~/components/icons/syncro.vue';
import SettingsIcon from '~/components/icons/settings.vue';
import Datepicker from '~/components/ui/Datepicker.vue';
import { ref, watch, onMounted, onUnmounted } from 'vue';
 import moment from 'moment';
 import 'moment/locale/de'; 
import axios from 'axios';
const { data, signOut } = useAuth();
const user = ref('');
const route = useRoute();
interface TreeItem {
    id: string | number;
    Bezeichnung: string;
}
const synchrolast = ref<string>('');
const synchronext = ref<string>('');
const valnameNL = ref<TreeItem[]>([]);
var get_notifi_data = ref([]);
var get_notifi_data_tomorrow = ref([]);

const nlId = ref(localStorage.getItem('NL_ID'));
const { $emitter } = useNuxtApp();

const updateNLId = () => {
    nlId.value = localStorage.getItem('NL_ID');
    get_localstorage();
};
const updateNLId_intern = () => {
    nlId.value = localStorage.getItem('NL_ID_Intern');
    get_localstorage_intern();
};
const get_localstorage = async () => {
    try {
        var nlid = localStorage.getItem('NL_ID');
        nlId.value = nlid;
        var windowsname = localStorage.getItem('windows_name');
        if (!windowsname) return;
        windowsname = encodeURIComponent(windowsname).replace('%20', '');
        const token = sessionStorage.getItem('temp_tok_laravel');
        const { data } = await axios.post(
            'https://api.tempton-connect.de/api/nutzer/benutzer',
            { windowsname },
            {
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }
        );
        valnameNL.value = data.data;
    } catch (error) {
        console.error('Error fetching user tree access:', error);
    }
};
const get_localstorage_intern = async () => {
    try {
        var nlid_intern = localStorage.getItem('NL_ID_Intern');
        nlId.value = nlid_intern;
        const token = sessionStorage.getItem('temp_tok_laravel');
        const { data } = await axios.get(
            'https://api.tempton-connect.de/api/nutzer/organisationintern',
            {
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }
        );

        valnameNL.value = data.data;
    } catch (error) {
        console.error('Error fetching user tree access:', error);
    }
};
const get_synchro = async () => {
    try {
        const token = sessionStorage.getItem('temp_tok_laravel');
        const { data } = await axios.get(
            'https://api.tempton-connect.de/api/default/Synchronisationsverlauf',

            {
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }
        );

        synchrolast.value = moment(data.data[0].LetzteSynchro).format('DD.MM.YYYY , LT');
        synchronext.value = moment(data.data[0].NaechsteSynchro).format('DD.MM.YYYY , LT');
   
    } catch (error) {
        console.error('Error fetching user tree access:', error);
    }
};
const get_notification = async () => {
    try {
        let today: string = moment(new Date()).format('YYYY-MM-DD');
        // const stDatum ='2021-06-20' ;
        //  const endDate ='2021-06-20' ;
        const von = today;
        const bis = today;
        var windowsname = localStorage.getItem('windows_name');
        windowsname = encodeURIComponent(windowsname).replace('%20', '');
        const token = sessionStorage.getItem('temp_tok_laravel');
        const { data } = await axios.post(
            'https://api.tempton-connect.de/api/intern/Notification',
            { windowsname, von, bis },
            {
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }
        );
        get_notifi_data.value = data.data;
        //console.log(get_notifi_data.value.length);
    } catch (error) {
        console.error('Error fetching user tree access:', error);
    }
};
const get_notification_tomorrow = async () => {
    try {
        let today = new Date();

        let tomorrowDate = new Date(today);
        tomorrowDate.setDate(tomorrowDate.getDate() + 1);

        let tomorrow: string = moment(tomorrowDate).format('YYYY-MM-DD');

        // const stDatum ='2021-01-01' ;
        // const endDate ='2021-01-01' ;
        const stDatum = tomorrow;
        const endDate = tomorrow;
        const von = tomorrow;
        const bis = tomorrow;

        var windowsname = localStorage.getItem('windows_name');
        windowsname = encodeURIComponent(windowsname).replace('%20', '');
        const token = sessionStorage.getItem('temp_tok_laravel');
        const { data } = await axios.post(
            'https://api.tempton-connect.de/api/intern/Notification',
            { windowsname, von, bis },

            {
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }
        );
        get_notifi_data_tomorrow.value = data.data;
        // console.log(get_notifi_data_tomorrow.value.length);
    } catch (error) {
        console.error('Error fetching user tree access:', error);
    }
};
get_notification();
get_notification_tomorrow();
get_synchro();
onMounted(async () => {
    const checkReady = () => {
        return (
            localStorage.getItem('windows_name') &&
            sessionStorage.getItem('temp_tok_laravel')
        );
    };

    const waitUntilReady = async () => {
        let retries = 0;
        while (!checkReady() && retries < 20) {
            await new Promise((resolve) => setTimeout(resolve, 300));
            retries++;
        }

        if (route.path.includes('/intern/')) {
            updateNLId_intern();
            $emitter.on('selecttree', updateNLId_intern);
        } else {
            updateNLId();
            $emitter.on('selecttree', get_localstorage);
        }
    };

    await waitUntilReady();
});

const glbevent = () => {
    $emitter.emit('click-info');
};
watch(
    () => route.path,
    (newPath) => {
        if (newPath.includes('/intern/')) {
            updateNLId_intern();
            $emitter.off('selecttree', get_localstorage);
            $emitter.on('selecttree', get_localstorage_intern);
        } else {
            updateNLId();
            $emitter.off('selecttree', get_localstorage_intern);
            $emitter.on('selecttree', get_localstorage);
        }
    },
    { immediate: true }
);

const selectedDate = defineModel<(number | Date)[]>('selectedDate', {
    default: () => [new Date(new Date().getFullYear(), 0, 1), new Date()],
});
</script>

<template>
    <div class="flex justify-between my-4 mx-12">
        <div class="flex space-x-4">
            <div>
                <datepicker v-model="selectedDate" :auto-position="true" />
            </div>

            <MenuDropdown>
                <template #dropdown-btn>
                    <button
                        class="px-4 py-2 bg-white border border-grey-light text-sm rounded-md text-grey-darker flex items-center space-x-3"
                        @click="glbevent()"
                    >
                        <NetworkIcon />
                        <span
                            ><div v-for="x in valnameNL" :key="x.id">
                                <div v-if="String(x.id) === nlId">
                                    {{ x.Bezeichnung }}
                                </div>
                            </div></span
                        >
                    </button>
                </template>
                <template #dropdown-content>
                    <div class="custom-dropdown-gb"></div>
                </template>
            </MenuDropdown>
        </div>

        <div class="flex items-center space-x-6">
            <MenuDropdown>
                <template #dropdown-btn>
                    <div class="custom-btn-sync">
                        <button type="button" class="relative">
                            <synchronize class="size-6" />
                        </button>
                    </div>
                </template>
                <template #dropdown-content>
                    <div class="custom-dropdown-sync">
                        <p class="font-medium mb-1">
                            Letzte Synchronisation:<br />{{ synchrolast }}
                        </p>
                        <p class="font-medium mb-1">
                            Nächste Synchronisation:<br />{{ synchronext }}
                        </p>
                    </div>
                </template>
            </MenuDropdown>
            <MenuDropdown>
                <template #dropdown-btn>
                    <button type="button" class="relative">
                        <NotificationIcon class="size-6" />
                        <span
                            class="bg-primary text-white rounded-full text-[0.6rem] size-5 inline-flex items-center justify-center absolute -top-2 -right-2 font-thin"
                            >{{
                                get_notifi_data.length +
                                get_notifi_data_tomorrow.length
                            }}</span
                        >
                    </button>
                </template>
                <template #dropdown-content>
                    <div class="custom-dropdown-content">
                        <div
                            class="flex flex-row mb-3 pb-3 border-b"
                            v-for="n in get_notifi_data"
                            :key="n.id"
                        >
                            <div v-if="n.Anlass === 'Geburtstag'">
                                <router-link :to="`personalevent`">
                                    <p class="iconsminds-cake icon_gt"></p>
                                </router-link>
                            </div>
                            <div v-else>
                                <router-link :to="`personalevent`">
                                    <p class="iconsminds-medal icon_jb"></p>
                                </router-link>
                            </div>
                            <div class="pl-3 pr-2">
                                <router-link :to="`personalevent`">
                                    <p class="font-weight-medium mb-1">
                                        {{ n.EventText }}
                                    </p>
                                    <p class="text-muted mb-0 text-small">
                                        Heute
                                    </p>
                                </router-link>
                            </div>
                        </div>
                        <div
                            class="flex flex-row mb-3 pb-3 border-b"
                            v-for="m in get_notifi_data_tomorrow"
                            :key="m.id"
                        >
                            <div v-if="m.Anlass === 'Geburtstag'">
                                <router-link :to="`personalevent`">
                                    <p class="iconsminds-cake icon_gt"></p>
                                </router-link>
                            </div>
                            <div v-else>
                                <router-link :to="`personalevent`">
                                    <p class="iconsminds-medal icon_jb"></p>
                                </router-link>
                            </div>
                            <div class="pl-3 pr-2">
                                <router-link :to="`personalevent`">
                                    <p class="font-weight-medium mb-1">
                                        {{ m.EventText }}
                                    </p>
                                    <p class="text-muted mb-0 text-small">
                                        Morgen
                                    </p>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </template>
            </MenuDropdown>
            <MenuDropdown>
                <template #dropdown-btn>
                    <button
                        class="px-4 py-2 bg-white border border-grey-light text-sm rounded-md text-grey-darker flex items-center space-x-3"
                    >
                        <span>{{ data?.user?.name ?? '...' }}</span>
                        <SettingsIcon class="size-4" />
                    </button>
                </template>
                <template #dropdown-content>
                    <button
                        type="button"
                        class="px-4 py-2 flex gap-2 text-sm items-center cursor-pointer"
                        @click="signOut()"
                    >
                        <i
                            class="font-simpleicons simple-icon-logout text-red-600"
                        />
                        {{ $t('base.logout') }}
                    </button>
                </template>
            </MenuDropdown>
        </div>
    </div>
</template>

<style scoped>
.-right-2 {
    right: -10px !important;
}
.-top-2 {
    top: 10px;
}

.custom-dropdown-content {
    @apply bg-white shadow-lg   max-h-96 overflow-y-auto w-[17rem] pt-[15px] pl-[15px] pr-[15px];
}

.custom-dropdown-content .border-b {
    @apply border-gray-300;
}

.custom-dropdown-content .pl-3 {
    @apply pl-5;
}

.custom-dropdown-content .pr-2 {
    @apply pr-4;
}

.custom-dropdown-content .text-muted {
    @apply text-gray-400 text-xs;
}

.custom-dropdown-content .font-weight-medium {
    @apply font-medium text-sm;
}
.custom-dropdown-content .iconsminds-cake {
    @apply text-2xl pt-[7px];
}

.custom-dropdown-content .iconsminds-medal {
    @apply text-2xl pt-[7px];
  
}
.custom-dropdown-gb {
    display: none;
}
.custom-dropdown-sync {
    @apply bg-white shadow-lg  max-h-96 w-[15rem] pt-[15px] pl-[15px] pr-[15px] pb-[15px];
}
.custom-btn-sync
{
margin-top: 5px;
}
</style>
